export default {
  // 边上的文案
  edgeLabels: {
    addressOwnership: "地址归属",
    firstInflow: "首笔流入",
    total: "共",
    transactions: "笔交易",
  },
};
